import { useCallback } from 'react';
import { useGetVariantsSelector } from '../../../../state/SplitTests/selectors/useGetVariantsSelector';
import { useDisableSplitTest } from '../../../../state/SplitTests/actions/useDisableSplitTest';
import { useRemoveDisplayWebContent } from '../state/actions/useRemoveDisplayWebContent';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';

export const useDeleteAllVariants = () => {
  const { state, dispatch } = useWorkFlowCanvas();
  const getVariants = useGetVariantsSelector();
  const removeDisplayWebsiteContent = useRemoveDisplayWebContent();
  const disableSplitTest = useDisableSplitTest();

  return useCallback(
    ({ splitTestId }: { splitTestId: string }) => {
      const { nodes, edges } = Canvas.createFromState(state)
        .removeNode(splitTestId)
        .convertToState();

      dispatch({
        type: 'UPDATE',
        payload: { nodes, edges },
      });

      getVariants(splitTestId)
        .map(s => s.messageId)
        .forEach(s => {
          removeDisplayWebsiteContent(s);
        });

      disableSplitTest({ id: splitTestId });
    },
    [disableSplitTest, dispatch, getVariants, removeDisplayWebsiteContent, state],
  );
};
